export default __webpack_public_path__ + "static/media/image-frame-3.590b35b1.jpg";